<div class="model-tab flex flex-col gap-6">
  <div class="model-tab__columns flex flex-col gap-6 lg:flex-row lg:items-start">
    <div class="model-tab__col-main flex flex-col gap-6 flex-1 min-w-0 lg:basis-[66%]">
      <section class="model-tab__card">
        <h2 class="model-tab__card-title">Description</h2>
        @if (modelDescription()) {
          <p
            class="model-tab__body text-[var(--text-color-2)] text-sm leading-relaxed whitespace-pre-wrap m-0"
          >
            {{ modelDescription() }}
          </p>
        } @else {
          <p class="model-tab__body text-[var(--text-muted-on-light)] m-0">No description available.</p>
        }
      </section>

      <section class="model-tab__card">
        <h2 class="model-tab__card-title">Model details</h2>
        <div class="model-tab__details-grid grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Created at</span>
            <span class="model-tab__cell-value">{{ detailRows()['createdAt'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">File Format</span>
            <span class="model-tab__cell-value">{{ detailRows()['fileFormat'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">File Size</span>
            <span class="model-tab__cell-value">{{ detailRows()['fileSize'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Industry</span>
            <span class="model-tab__cell-value">{{ detailRows()['industry'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Last Updated</span>
            <span class="model-tab__cell-value">{{ detailRows()['lastUpdated'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">License</span>
            <span class="model-tab__cell-value">{{ detailRows()['license'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Model Permission</span>
            <span class="model-tab__cell-value">{{ detailRows()['modelPermission'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Model Type</span>
            <span class="model-tab__cell-value">{{ detailRows()['modelType'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Organisation Type</span>
            <span class="model-tab__cell-value">{{ detailRows()['organisationType'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Organisation name</span>
            <span class="model-tab__cell-value">{{ detailRows()['organisationName'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Publisher</span>
            <span class="model-tab__cell-value">{{ detailRows()['publisher'] || '—' }}</span>
          </div>
          <div class="model-tab__cell">
            <span class="model-tab__cell-label">Uploaded by</span>
            <span class="model-tab__cell-value">{{ detailRows()['uploadedBy'] || '—' }}</span>
          </div>
        </div>
      </section>
    </div>

    <aside class="model-tab__col-side flex flex-col gap-6 flex-1 min-w-0 lg:basis-[33%] lg:max-w-md">
      <section class="model-tab__card model-tab__card--sidebar">
        <h2 class="model-tab__card-title">Activity Overview</h2>
        <div class="model-tab__badges flex flex-wrap gap-3">
          <div class="model-tab__badge inline-flex items-center gap-2">
            <img src="/icons/thumbs-up-teal.svg" width="18" height="18" alt="" />
            <span>{{ formatMetric(activityMetrics().likes) }}</span>
          </div>
          <div class="model-tab__badge inline-flex items-center gap-2">
            <img src="/icons/eye-teal.svg" width="18" height="18" alt="" />
            <span>{{ formatMetric(activityMetrics().views) }}</span>
          </div>
          <div class="model-tab__badge inline-flex items-center gap-2">
            <img src="/icons/download-teal.svg" width="18" height="18" alt="" />
            <span>{{ formatMetric(activityMetrics().downloads) }}</span>
          </div>
        </div>
      </section>

      <section class="model-tab__card model-tab__card--sidebar">
        <h2 class="model-tab__card-title">Metadata</h2>
        <div class="model-tab__meta-stack flex flex-col gap-6">
          <div>
            <span class="model-tab__meta-label">Keywords</span>
            <div class="model-tab__tags flex flex-wrap gap-2 mt-2">
              @for (kw of modelTags(); track kw) {
                <span class="model-tab__tag">{{ kw }}</span>
              }
              @if (!modelTags().length) {
                <span class="model-tab__meta-muted">No keywords</span>
              }
            </div>
          </div>
        </div>
      </section>

      @if (hasGithubAction()) {
        <section class="model-tab__card model-tab__card--sidebar model-tab__card--actions">
          <h2 class="model-tab__card-title">Actions</h2>
          <div class="model-tab__actions-grid model-tab__actions-grid--single" role="group" aria-label="Model actions">
            <button
              type="button"
              class="model-tab__btn model-tab__btn--primary model-tab__btn--full"
              (click)="onGithubRepoClick()"
            >
              <span class="model-tab__btn-icon" aria-hidden="true">
                <img src="/icons/github.svg" width="20" height="20" alt="" />
              </span>
              <span class="model-tab__btn-label">GitHub Repo</span>
              <span class="model-tab__btn-icon" aria-hidden="true">
                <img src="/icons/arrow-white-circle.svg" width="20" height="20" alt="" />
              </span>
            </button>
          </div>
        </section>
      }
    </aside>
  </div>
</div>
